import {
  format,
  parseISO,
  startOfDay,
  addMonths,
} from 'date-fns';

/**
 *
 * @param {Array.<string>} array
 * @returns {Object}
 */
export const mapComputed = (array) => array.reduce((acc, cur) => {
  Object.assign(acc[cur], JSON.parse(sessionStorage.getItem(cur)));
  return acc;
}, {});
export const getFormattedDate = (date, formatting) => ((typeof date === 'string') ? format(parseISO(date), formatting) : format(date, formatting));
export const additionalTimeHelper = (date, months, additional = 0) => {
  const startDate = addMonths(startOfDay(new Date(date)), months + additional);
  return format(startDate, 'MMMM dd, yyyy');
};
export const icoaAmountFormatted = ({ icoaAmount }) => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
}).format(icoaAmount / 100);
